<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <!--    add new checkpoint card-->
    @if ("!disableEditing") {
      <app-admin-card-with-title [cardTitle]="t('organiser.event.details.add.new.checkpoint')" [removeTopMargin]="true">
        <div class="row">
          <div class="col-12 col-xl-4">
            <div class="d-flex flex-column h-100">
              <div class="pb-3">
                <app-language-input [inputForm]="inputForm" [defaultLanguage]="event?.defaultLanguage"
                                    [extraLanguages]="event?.extraLanguages" [hrKey]="'pointNameHr'"
                                    [enKey]="'pointNameEn'"
                                    [itKey]="'pointNameIt'" [siKey]="'pointNameSlo'" [srKey]="'pointNameSr'" [bsKey]="'pointNameBs'"
                                    [hrLabel]="'organiser.event.details.control.point.nameCro'"
                                    [srLabel]="'organiser.event.details.control.point.nameSr'"
                                    [bsLabel]="'organiser.event.details.control.point.nameBs'"
                                    [enLabel]="'organiser.event.details.control.point.nameEn'"
                                    [itLabel]="'organiser.event.details.control.point.nameIt'"
                                    [siLabel]="'organiser.event.details.control.point.nameSlo'"/>
              </div>
              <!-- Waypoint type dropdown -->
              <div class="pb-3">
                <div class="d-flex align-items-top mb-3">
                  <div class="flex-grow-1">
                    <app-select formControlName="waypointTypeId" [items]="waypointTypes"
                                labelKeyPrefix="organiser.event.details.control.point.waypointType." valueKey="id"
                                labelKey="id"
                                label="organiser.event.details.control.point.type" [isDropdownListFullWidth]="true"/>
                  </div>
                  <div class="info-box">
                    <i class="fa-regular fa-copy" (click)="openSelectWaypointFromEventModal()"
                       ngbTooltip="{{ t('organiser.event.details.control.point.copy') }}"
                       placement="left"></i>
                  </div>
                </div>
              </div>
              @if (inputForm.value.waypointTypeId && (inputForm.value.waypointTypeId
                === WaypointType.CONTROL_WAYPOINT)) {
                <div class="pb-3">
                  <app-input type="number" formControlName="ordinalNumber"
                             label="organiser.event.details.control.point.ordinalNumber" [min]="1" [max]="100"/>
                </div>
                <div class="pb-3">
                  <app-date-time-input formControlName="limit" [displayTime]="true" [minDate]="race?.raceStart"
                                       [maxDate]="race?.raceEnd"
                                       [label]="t('organiser.event.details.control.point.timeLimit')"/>
                </div>
              }
              @if (inputForm.value.waypointTypeId && (inputForm.value.waypointTypeId ===
                WaypointType.START_WAYPOINT || inputForm.value.waypointTypeId
                === WaypointType.FINISH_WAYPOINT)) {
                <div class="pb-3">
                  <app-input formControlName="city" label="organiser.event.details.control.point.city"/>
                </div>
                <div class="pb-3">
                  <app-input formControlName="address" label="organiser.event.details.control.point.address"/>
                </div>
                <div class="pb-3">
                  <app-select formControlName="country" [hasDefault]="true" [items]="countries" [labelKey]="'name'"
                              [valueKey]="'id'" label="organiser.event.details.control.point.country"/>
                </div>
                <div class="pb-3">
                  <app-input formControlName="additionalMark"
                             label="organiser.event.details.control.point.additionalMark"/>
                </div>
                <div class="pb-3">
                  <app-language-input [inputForm]="inputForm" [defaultLanguage]="event?.defaultLanguage" [required]="false"
                                      [extraLanguages]="event?.extraLanguages" [hrKey]="'descriptionHr'"
                                      [enKey]="'descriptionEn'"
                                      [itKey]="'descriptionIt'"
                                      [siKey]="'descriptionSlo'"
                                      [srKey]="'descriptionSr'"
                                      [bsKey]="'descriptionBs'"
                                      [hrLabel]="'organiser.event.details.control.point.descriptionCro'"
                                      [srLabel]="'organiser.event.details.control.point.descriptionSr'"
                                      [bsLabel]="'organiser.event.details.control.point.descriptionBs'"
                                      [enLabel]="'organiser.event.details.control.point.descriptionEn'"
                                      [itLabel]="'organiser.event.details.control.point.descriptionIt'"
                                      [siLabel]="'organiser.event.details.control.point.descriptionSlo'"/>
                </div>
              }

              @if (inputForm.value.waypointTypeId && (inputForm.value.waypointTypeId ===
                WaypointType.START_WAYPOINT)) {
                <div class="pb-3">
                  <app-checkpoint-input formControlName="latitude" label="event.item.location.latitude"
                                        [showCopyIcon]="!!this.raceRoute?.content"
                                        (copyIconClick)="onCopyStartFromMap()"
                                        tooltipText="{{ t('organiser.event.details.copy.start.location.from.map') }}"/>
                </div>
                <div class="pb-3">
                  <app-checkpoint-input formControlName="longitude" label="event.item.location.longitude"
                                        [showCopyIcon]="!!this.raceRoute?.content"
                                        (copyIconClick)="onCopyStartFromMap()"
                                        tooltipText="{{ t('organiser.event.details.copy.start.location.from.map') }}"/>
                </div>
              } @else if (inputForm.value.waypointTypeId && (inputForm.value.waypointTypeId
                === WaypointType.FINISH_WAYPOINT)) {
                <div class="pb-3">
                  <app-checkpoint-input formControlName="latitude" label="event.item.location.latitude"
                                        [showCopyIcon]="!!this.raceRoute?.content" (copyIconClick)="onCopyEndFromMap()"
                                        tooltipText="{{ t('organiser.event.details.copy.end.location.from.map') }}"/>
                </div>
                <div class="pb-3">
                  <app-checkpoint-input formControlName="longitude" label="event.item.location.longitude"
                                        [showCopyIcon]="!!this.raceRoute?.content" (copyIconClick)="onCopyEndFromMap()"
                                        tooltipText="{{ t('organiser.event.details.copy.end.location.from.map') }}"/>
                </div>
              } @else {
                <div class="pb-3">
                  <app-input formControlName="latitude" label="event.item.location.latitude"/>
                </div>
                <div class="pb-3">
                  <app-input formControlName="longitude" label="event.item.location.longitude"/>
                </div>
              }
              <div class="pb-3">
                <app-input formControlName="distanceFromStart"
                           label="organiser.event.details.control.point.distanceFromStart"/>
              </div>
              <div class="pb-3">
                <app-input formControlName="elevation" label="organiser.event.details.control.point.elevation"/>
              </div>
              @if (inputForm.value.waypointTypeId && (inputForm.value.waypointTypeId ===
                WaypointType.CONTROL_WAYPOINT || inputForm.value.waypointTypeId
                === WaypointType.OTHER_WAYPOINT)) {
                <div class="pb-3">
                  <app-multiselect-dropdown [options]="getOptions()" [formControlName]="'markerTypes'"
                                            [dropdownLabel]="t('organiser.event.details.control.point.marker.types')"
                                            [isDropdownListFullWidth]="true"/>
                </div>
              }
              <div class="form-floating">
                <div class="mt-3 mb-3 d-flex align-items-center">
                  <app-checkbox formControlName="pointSelection"
                                label="organiser.event.details.control.point.selection.enabled"
                                (click)="togglePointSelection()"/>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-xxl-4 reduce-column-right-spacing">
                  <div class="mt-3">
                    <app-rounded-button [label]="t('organiser.event.details.cancel.checkpoint')" (onClick)="onCancel()"
                                        [isDisabled]="!hasFormAnyValue()"
                                        [btnClass]="'w-100'"></app-rounded-button>
                  </div>
                </div>
                <div class="col-12 col-xxl-8">
                  <div class="my-3">
                    <app-rounded-button
                      [label]="currentWaypoint.id ? t('organiser.event.details.save.changes.checkpoint') : t('organiser.event.details.add.new.checkpoint')"
                      (onClick)="onSave()" [isDisabled]="!inputForm.valid" [btnClass]="'w-100'"></app-rounded-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-8">
            <div class="map-placeholder position-relative">
              @if (raceSettings?.usingUploadRoute) {
                <div class="d-flex flex-row justify-content-end mb-4 map-cta-placeholder">
                  <div class="input-holder">
                    <input type="file" class="file-input" accept="application/gpx+xml" #fileUpload
                           (change)="processFile(fileUpload)">
                  </div>
                  <div class="d-flex flex-row justify-content-end">
                    <app-rounded-button [label]="t('organiser.event.details.add.gpx.route')"
                                        (onClick)="fileUpload.click()"
                                        [btnClass]="'rounded-button--solid'">
                    </app-rounded-button>
                    @if (raceRoute?.content) {
                      <div class="ps-4">
                        <app-rounded-button [label]="t('organiser.event.details.delete.gpx.route')"
                                            (onClick)="onDeleteGpxFile()"
                                            [btnClass]="'rounded-button--black-outline rounded-button--solid'">
                        </app-rounded-button>
                      </div>
                    }
                  </div>
                </div>
              }
              <app-leaflet-maps-wrapper [isEraseLocationEnabled]="false"
                                        [isGetLocationEnabled]="false" [isShowLocationMarkerEnabled]="false"
                                        [gpx]="gpx" [positionAbsolute]="true"
                                        [isPointSelectionEnabled]="isPointSelectionEnabled" [points]="waypointList"
                                        [defaultLanguage]="event?.defaultLanguage" [languages]="languages"
                                        [currentlyEditingPoint]="currentWaypoint"
                                        (onSelectPoint)="onSelectPoint($event)"/>
            </div>
          </div>
        </div>
      </app-admin-card-with-title>
    }

    <app-admin-card-with-title [cardTitle]="t('organiser.event.details.control.point.list')"
                               [isContentVisible]="!isTableCollapsed" [showToggleButton]="true">
      @if ((waypointList?.length ?? 0) > 0) {
        <div class="row">
          <div class="col-12">
            <div class="table-responsive d-xl-block d-none">
              @if (this.waypointList && waypointList!.length > 0) {
                <app-sortable-table cssClass="table dark-header table-last-row-no-border" [items]="waypointList">
                  <thead>
                  <tr>
                    <th scope="col" [sortBy]="[getNameColumn()]" class="name-column-width">
                      {{ t("organiser.event.details.control.point.name") }}
                    </th>
                    <th scope="col" class="type-column-width">
                      {{ t("organiser.event.details.control.point.type") }}
                    </th>
                    <th scope="col" [sortBy]="['ordinalNumber']" class="ordinal-number-column-width">
                      {{ t("organiser.event.details.control.point.ordinalNumber") }}
                    </th>
                    <th scope="col" [sortBy]="['timeLimit']" class="time-column-width">
                      {{ t("organiser.event.details.control.point.timeLimit") }}
                    </th>
                    <th scope="col" class="location-column-width"
                        [sortBy]="['city', 'address', 'additionalMark', 'country', 'longitude', 'latitude']">
                      {{ t("organiser.event.details.control.point.location") }}
                    </th>
                    <th scope="col" [sortBy]="['distanceFromStart']" class="distance-column-width">
                      {{ t("organiser.event.details.control.point.distanceFromStart") }}
                    </th>
                    <th scope="col" [sortBy]="['elevation']" class="elevation-column-width">
                      {{ t("organiser.event.details.control.point.elevation") }}
                    </th>
                    <th scope="col" class="more-column-width">
                    </th>
                  </tr>
                  </thead>
                  <tr app-table-header-separator></tr>
                  <tbody>
                    @for (waypoint of waypointList; track waypoint.id) {
                      <tr>
                        <td class="center-align">
                          <app-language-output [hrLabel]="waypoint.pointNameHr" [enLabel]="waypoint.pointNameEn" [srLabel]="waypoint.pointNameSr" [bsLabel]="waypoint.pointNameBs"
                                               [itLabel]="waypoint.pointNameIt" [siLabel]="waypoint.pointNameSlo"
                                               [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
                        </td>
                        <td class="center-align">
                          <div class="status-badge mb-4px"
                               [ngClass]="{'blue': waypoint.waypointTypeId === 1 , 'accepted':
                               waypoint.waypointTypeId === 2, 'denied': waypoint.waypointTypeId === 3 , 'on-hold': waypoint.waypointTypeId === 4}">
                              <span class="fw-bold">
                                {{
                                  t("organiser.event.details.control.point.waypointType."
                                    + waypoint.waypointTypeId) | uppercase
                                }}
                              </span>
                          </div>
                        </td>
                        <td class="center-align">{{ waypoint.ordinalNumber }}</td>
                        <td class="center-align">{{
                            waypoint.limit
                              ? (waypoint.limit | localizedDate:'short')
                              : ''
                          }}
                        </td>
                        <td class="center-align">
                          @if (waypoint.waypointTypeId === WaypointType.START_WAYPOINT || waypoint.waypointTypeId ===
                          WaypointType.FINISH_WAYPOINT) {
                            <div>
                              {{ waypoint | waypointLocation:countries }}
                            </div>
                          }
                          <div>{{ "Lat: " }}{{ (waypoint?.latitude ?? '-') }}</div>
                          <div>{{ "Lng: " }}{{ (waypoint?.longitude ?? '-') }}</div>
                        </td>
                        <td class="center-align">{{
                            (waypoint.distanceFromStart === 0 || waypoint.distanceFromStart) ?
                              waypoint.distanceFromStart + " m"
                              : ""
                          }}
                        </td>
                        <td class="center-align">{{
                            (waypoint.elevation === 0 || waypoint.elevation) ? waypoint.elevation + " m" :
                              waypoint.elevation
                          }}
                        </td>
                        <td class="text-end center-align">
                          @if (!disableEditing) {
                            <div class="dropdown dropdown--remove-arrow" container="body" ngbDropdown>
                      <span class="menu-icon" id="checkpointActionsDropdown" ngbDropdownToggle>
                        <i class="fas fa-ellipsis-v"></i>
                      </span>
                              <ul aria-labelledby="checkpointActionsDropdown" ngbDropdownMenu>
                                <li ngbDropdownItem (click)="onEditWaypoint(waypoint)">{{
                                    t(
                                      "app.common.edit")
                                  }}
                                </li>
                                @if (waypoint.waypointTypeId === WaypointType.CONTROL_WAYPOINT
                                || waypoint.waypointTypeId
                                === WaypointType.OTHER_WAYPOINT) {
                                  <li ngbDropdownItem (click)="onCopyWaypoint(waypoint)">{{
                                      t(
                                        "app.common.copy")
                                    }}
                                  </li>
                                }

                                @if(!(waypoint.waypointTypeId === WaypointType.START_WAYPOINT
                                || waypoint.waypointTypeId
                                === WaypointType.FINISH_WAYPOINT)){
                                <li ngbDropdownItem (click)="onDeleteWaypoint(waypoint)">{{
                                t(
                                  "app.common.delete")
                                }}
                                </li>
                                }
                              </ul>
                            </div>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </app-sortable-table>
              } @else {
                <div class="my-3">
                  <app-empty-state-admin/>
                </div>
              }
            </div>
            <!-- Mobile table-->
            @if ((waypointList?.length ?? 0) > 0) {
              @for (waypoint of waypointList; track waypoint.id; let isLast = $last) {
                <div class="d-block d-xl-none pb-3">
                  <div [class.isLastRow]="isLast"
                       class="d-flex justify-content-center align-items-center mobile-table-row">
                    <div class="flex-grow-1">
                      <div [class.isLastRow]="isLast" class="d-flex flex-column">
                        <div>
                          <strong>{{ t("organiser.event.details.control.point.name") }}:</strong>
                          {{ waypoint.pointNameHr }}
                        </div>
                        <div>
                          <strong>{{ t("organiser.event.details.control.point.type") }}:</strong>
                          &nbsp;{{ t("organiser.event.details.control.point.waypointType." + waypoint.waypointTypeId) }}
                        </div>
                        <div>
                          <strong>{{ t("organiser.event.details.control.point.ordinalNumber") }}:</strong>
                          {{ waypoint.ordinalNumber }}
                        </div>
                        <div>
                          <strong>{{ t("organiser.event.details.control.point.timeLimit") }}:</strong>
                          {{
                            waypoint.limit
                              ? (waypoint.limit | localizedDate:'short')
                              : ''
                          }}
                        </div>
                        <div>
                          <strong>{{ "Lat/Lng: " }}</strong>{{
                            (waypoint?.latitude ?? '-') + '/' + (waypoint?.longitude ?? '-')
                          }}
                        </div>
                        <div>
                          <strong>{{ t("organiser.event.details.control.point.distanceFromStart") }}:</strong>
                          {{
                            (waypoint.distanceFromStart === 0 || waypoint.distanceFromStart)
                              ? waypoint.distanceFromStart + " m" : ""
                          }}
                        </div>
                        <div>
                          <strong>{{ t("organiser.event.details.control.point.elevation") }}:</strong>
                          {{
                            (waypoint.elevation === 0 || waypoint.elevation) ? waypoint.elevation + " m"
                              : ""
                          }}
                        </div>
                      </div>
                    </div>
                    <div>
                      @if (!disableEditing) {
                        <div class="dropdown dropdown--remove-arrow" container="body" ngbDropdown>
                  <span class="menu-icon" id="checkpointActionsDropdownMobile" ngbDropdownToggle>
                    <i class="fas fa-ellipsis-v"></i>
                  </span>
                          <ul aria-labelledby="checkpointActionsDropdown" ngbDropdownMenu>
                            <li ngbDropdownItem (click)="onEditWaypoint(waypoint)">{{ t("app.common.edit") }}</li>
                            @if (waypoint.waypointTypeId === WaypointType.CONTROL_WAYPOINT || waypoint.waypointTypeId
                            === WaypointType.OTHER_WAYPOINT) {
                              <li ngbDropdownItem (click)="onCopyWaypoint(waypoint)">{{
                                  t(
                                    "app.common.copy")
                                }}
                              </li>
                            }
                            <li ngbDropdownItem (click)="onCopyWaypoint(waypoint)">{{ t("app.common.delete") }}</li>
                            <li ngbDropdownItem (click)="onDeleteWaypoint(waypoint)">{{ t("app.common.delete") }}</li>
                          </ul>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            } @else {
              <div class="justify-content-center d-flex  d-xl-none">
                <div class="py-4">
                  {{ t("organiser.event.details.no.inputted.checkpoints") }}
                </div>
              </div>
            }
          </div>
        </div>
      }
    </app-admin-card-with-title>

    <app-action-buttons-row [saveVisible]="false"/>
  </form>
</ng-container>
